<template>
  <DialogTemplateToolkit
    :dialog="dialog"
    :disabled="disabled"
    first_btn="Common.Save"
    :title="$t('Purchasing.ChangeQuantity')"
    @apply="apply"
    @close="close">
    <template #activator-btn>
      <MenuItem
        class="h11-links"
        icon="edit"
        :label="$t('Purchasing.ToChangeQuantity')"
        @click="open"/>
    </template>
    <template #card-text>
      <div class="secondary__green_chosen pa-4">
        <div
          v-if="item.resource"
          class="h7-text secondary__green_not_active--text">
          {{ item.resource.category ? item.resource.category.code : '' }}
          {{ item.resource.category ? item.resource.category.name :
            item.resource.group ? item.resource.group.name
            : '' }}
        </div>
        <span class="h8-text black--text">
          {{ item.resource ? item.resource.name : item.resourceName || item.lotTitle }}
        </span>
      </div>
      <div
        v-if="item.lotId"
        class="mt-8">
        <div class="h9-label ">
          {{ $t('Tenders.ProposedAmount') }}
        </div>
        <div class="h7-text ">
          {{ item.quantity }} {{ item.unit ? item.unit.title : ' –' }}
        </div>
      </div>
      <sFormItem
        class="mt-4"
        :error="!quantity ? $t('Validate.Required') : ''"
        :label="$t('Application.SpecifyQuantity')">
        <sInput
          ref="quantity_input"
          :value.sync="quantity"
          @change="change"/>
      </sFormItem>
      <sFormItem
        class="mt-4"
        :error="!text ? $t('Validate.Required') : ''"
        :label="$t('Purchasing.WhyChange')">
        <sInput
          ref="quantity_input"
          :max-length="4000"
          rows="5"
          type="textarea"
          :value.sync="text"/>
      </sFormItem>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { modalMixin } from 'mixins'

export default {
  name: 'changeQuantity',
  mixins: [ modalMixin],
  data() {
    return {
      dialog: false,
      quantity: '',
      text: '',
    }
  },
  props: {
    elements: Array,
    not_change: Boolean
  },
  created() {
    this.quantity = this.item.quantity || this.item.approvedQuantity
  },
  computed: {
    disabled() {
      return !this.quantity || !this.commentRule(this.text, true) || (this.item.quantity || this.item.approvedQuantity ) == this.quantity
    },
    item: {
      get() {
        return this.elements[0] || {}
      },
      set(value) {
        this.$emit('update:elements', [value])
      }
    },
  },
  methods: {
    change() {
      this.quantity = +this.$_formatValue(this.quantity  || 0)
    },
    open() {
      if (this.dialog) {
        this.dialog = false
      }
      setTimeout(() => {
        this.dialog = true
      }, 100)
    },
    apply() {
      if (this.item.quantity == this.quantity) {
        return this.close()
      }
      if (this.not_change) {
        this.$emit('callback', this.quantity, this.text)
      } else {
        this.item.quantity = this.quantity
        this.item.comment = this.text
        this.$emit('callback')
      }
      this.close()
    },
    close() {
      this.text = ''
      this.dialog = false
    },
  },
  components: {
    MenuItem,
    DialogTemplateToolkit
  }
}
</script>
<style lang="scss" scoped>
.v-card__subtitle.secondary__green_chosen {
  border-radius: 8px;
}
.textarea {
  width: 100%;
}
</style>
